import { render, staticRenderFns } from "./Arbitrage.vue?vue&type=template&id=97790c74&scoped=true"
import script from "./Arbitrage.vue?vue&type=script&lang=js"
export * from "./Arbitrage.vue?vue&type=script&lang=js"
import style0 from "./Arbitrage.vue?vue&type=style&index=0&id=97790c74&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97790c74",
  null
  
)

export default component.exports